<template>
    <v-app>
        
        <!-- Public Navigation Header -->
        <header-card-public current_page="notfoundpage"></header-card-public>

        <!-- Main Clean Container -->
        <v-content class="restricted-container">
            <v-layout fill-height align-center justify-center class="fade">
                <v-flex xs12 sm8 md6 class="text-xs-center px-4">
                    
                    <!-- Visual Anchor: Broken Link / Search Icon -->
                    <div class="icon-wrapper mb-4">
                        <v-icon size="80" color="blue darken-2">search_off</v-icon>
                    </div>

                    <!-- Clear Copywriting Headers -->
                    <h1 class="headline font-weight-bold grey--text text--darken-3 mb-2">
                    Page Not Found
                    </h1>
                    <p class="subheading grey--text text--darken-1 mb-5">
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                    </p>

                    <!-- Action Buttons -->
                    <v-layout row wrap justify-center>
                        <!-- Primary Action -->
                        <v-btn 
                            color="primary" 
                            large 
                            class="mx-2 my-2 px-4 font-weight-medium elevation-1"
                            @click="$router.push('/')"
                        >
                            Back to Home Page
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-content>


    </v-app>
</template>

<script>
import '@/assets/css/public.css'

export default {
    components: {
        'header-card-public': () => import('@/components/Common/HeaderPublic')
    },
    data() {
    return {}
    },
}
</script>

<style scoped>
/* Modern, neutral soft background replacement */
.restricted-container {
    background-color: #f8f9fa; 
    height: 100vh;
}

/* Accent framing for the central icon */
.icon-wrapper {
    display: inline-block;
    background-color: #e3f2fd;
    padding: 24px;
    border-radius: 50%;
}

/* Smooth enter animation */
.fade {
    animation: fadeIn 0.6s ease-out;
}

@keyframes fadeIn {
    0% { opacity: 0; transform: translateY(10px); }
    100% { opacity: 1; transform: translateY(0); }
}
</style>
